"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.prompt-assist.disabled': 'La función de asistente de prompts no está disponible en su plan actual.',
};
